import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";

interface FinishBatchDialogProps {
  open: boolean;
  onConfirm: () => void;
}

const FinishBatchDialog: React.FC<FinishBatchDialogProps> = ({
  open,
  onConfirm,
}) => (
  <Dialog open={open}>
    <DialogTitle>Lot terminé</DialogTitle>
    <DialogContent>
      <DialogContentText>
        La labellisation de ce lot est terminée
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onConfirm} color="primary">
        OK
      </Button>
    </DialogActions>
  </Dialog>
);

export default FinishBatchDialog;
